import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withSnackbar } from 'notistack';
import { withRouter } from 'react-router-dom';

import withStyles from '@material-ui/core/styles/withStyles';
import DateFormatResolver, { fullDateUsFormat } from 'resolvers/date-format.resolver';
import schedulerViewMode from 'utils/enums/scheduler-view-mode.enum';
import {
	setSchedulerSettingActionCreator,
	setTableStateActionCreator,
} from 'plugins/store/reducers/common.reducer';
import { setNumberRowsPerPageActionCreator } from 'plugins/store/reducers/settings.reducer';
import { setAlertActionCreator } from 'plugins/store/reducers/common.reducer';

import { search, deleteAppointment } from 'services/appointment.service';
import CardBody from 'components/Card/CardBody';
import Tooltip from '@material-ui/core/Tooltip';
import Button from "components/CustomButtons/Button.js";
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
// import SyncAltIcon from '@material-ui/icons/SyncAlt';
import DeleteIcon from '@material-ui/icons/Delete';
import CreateIcon from '@material-ui/icons/Create';
import ReactTable from 'components/ReactTable/ReactTable';
import SnackMessage from 'components/Snackbar/SnackMessage';
import layoutNames from 'utils/enums/layout-names.enum';

const styles = {
	rightButton: {
		color: '#495057',
		height: '25px',
		marginTop: '-10px',
		'& svg': {
			width: '25px',
			height: '25px',
		},
	},
	actionsWrapper: {
		display: 'flex',
	},
	actionIcon: {
		height: '18px',
		'&:hover,&:focus': {
			filter: 'invert(.6)',
		},
		cursor: 'pointer',
	},
};

class ListView extends Component {
	state = {
		data: [],
		totalRecordsCount: 0,
		pageCount: 0,
	};

	columns = [
		{
			Header: 'Date',
			accessor: 'startTime',
			Cell: ({ value }) => {
				return DateFormatResolver.resolve(value, fullDateUsFormat);
			}
		},
		{
			Header: 'Call Purpose',
			accessor: 'callPurpose',
		},
		{
			Header: 'Contact Center',
			accessor: 'callCenterName',
		},
		{
			Header: 'Name of the CR',
			accessor: 'userName',
		},
		{
			Header: 'Status',
			accessor: 'status',
		},
		{
			Header: 'Actions',
			accessor: 'actions',
			disableFilters: true,
			disableSortBy: true,
			Cell: ({ row }) => {
				const id = row?.original?._id;
				return (
					<div className={this.props.classes.actionsWrapper}>
						{/* <Tooltip arrow title='Re-assign'>
							<SyncAltIcon onClick={() => {}} className={this.props.classes.actionIcon} />
						</Tooltip> */}
						<Tooltip arrow title='Edit'>
							<CreateIcon onClick={() => this.onEditClick(id)} className={this.props.classes.actionIcon} />
						</Tooltip>
						<Tooltip arrow title='Remove'>
							<DeleteIcon onClick={() => this.onDeleteClick(id)} className={this.props.classes.actionIcon} />
						</Tooltip>
					</div>);
			},
		},
	];

	toggleViewMode = () => {
		const viewMode =
			this.props.viewMode === schedulerViewMode.CALENDAR
				? schedulerViewMode.LIST
				: schedulerViewMode.CALENDAR;
		this.props.setSchedulerSetting('viewMode', viewMode);
	}

	onDeleteClick = (id) => {
		const {
			enqueueSnackbar,
			setAlert,
			rowsPerPage,
			defaultSearchQuery,
			defaultSortBy,
			defaultPageIndex,
			defaultDateRangeFilter,
		} = this.props;

		const deleteNotification = {
			type: 'warning',
			title: 'Do you want to remove this Appointment?',
			message: 'This action can not be undone',
			confirmBtnText: 'REMOVE',
			onConfirm: async () => {
				setAlert(null);
				try {
					await deleteAppointment(id);
					this.fetchData({
						filterQuery: defaultSearchQuery,
						pageIndex: defaultPageIndex,
						pageSize: rowsPerPage,
						sortBy: defaultSortBy,
						dateRangeFilter: defaultDateRangeFilter,
					});

					enqueueSnackbar(
						'Appointment successfully removed',
						{
							content: (key, message) => (
								<SnackMessage
									id={key}
									message={message}
									color="success"
								/>
							),
						}
					);
				} catch (e) {
					enqueueSnackbar(e.resolvedErrorMessage, {
						content: (key, message) => (
							<SnackMessage
								id={key}
								message={message}
								color="danger"
							/>
						),
					});
				}
			},
			onCancel: () => {
				setAlert(null);
			},
		};
		setAlert(deleteNotification);
	}

	onEditClick = (id) => {
		this.props.history.push(`/${layoutNames.portal}/scheduler/call/${id}`);
	}

	render() {
		const {
			classes,
			rowsPerPage,
			setRowsPerPage,
			defaultSearchQuery,
			defaultSortBy,
			defaultPageIndex,
			setTableState,
			defaultDateRangeFilter,
		} = this.props;

		this.fetchData = async ({
			filterQuery,
			pageIndex,
			pageSize,
			sortBy,
			dateRangeFilter,
		}) => {
			this.props.setLoading(true);
			const result = await search({
				filterQuery,
				pageIndex,
				pageSize,
				sortBy,
				dateRangeFilter,
			});
			this.setState({
				data: result.data,
				totalRecordsCount: result.totalCount,
				pageCount: Math.ceil(result.totalCount / pageSize),
			});
			this.props.setLoading(false);
			setRowsPerPage({
				table: 'appointmentList',
				rowsPerPage: pageSize
			});
			setTableState({
				table: 'appointmentList',
				state: {
					dateRangeFilter,
					searchQuery: filterQuery,
					sortBy: sortBy,
					page: pageIndex
				}
			});
		};

		return (
				<CardBody>
					<ReactTable
						clickableRows={false}
						rowsWithSelection={false}
						columns={this.columns}
						data={this.state.data}
						fetchData={this.fetchData}
						rowsPerPage={rowsPerPage}
						defaultSearchQuery={defaultSearchQuery}
						defaultSortBy={defaultSortBy}
						defaultPageIndex={defaultPageIndex}
						loading={this.props.loading}
						pageCount={this.state.pageCount}
						totalRecordsCount={this.state.totalRecordsCount}
						defaultDateRangeFilter={defaultDateRangeFilter}
						dateRangeCanBeLaterThanToday={true}
						addRecordComponent={
							<Tooltip
								arrow
								title="Schedule view"
							>
								<Button
									color="transparent"
									justIcon
									onClick={this.toggleViewMode}
									className={classes.rightButton}
								>
									<PermContactCalendarIcon />
								</Button>
							</Tooltip>
						}
						isPageRootComponent
					/>
			</CardBody>
		);
	}
}

const mapStateToProps = ({
	common: {
		tablesState: {
			appointmentList: {
				searchQuery,
				sortBy,
				dateRangeFilter,
				page,
			}
		},
		schedulerSettings,
	},
	settings: {
		rowsPerPage,
	}
}) => {
	return {
		viewMode: schedulerSettings.viewMode,
		rowsPerPage: rowsPerPage.appointmentList,
		defaultSearchQuery: searchQuery,
		defaultSortBy: sortBy,
		defaultDateRangeFilter: dateRangeFilter,
		defaultPageIndex: page,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setAlert: bindActionCreators(
		setAlertActionCreator,
		dispatch
	),
	setSchedulerSetting: bindActionCreators(
		setSchedulerSettingActionCreator,
		dispatch,
	),
	setRowsPerPage: bindActionCreators(
		setNumberRowsPerPageActionCreator,
		dispatch
	),
	setTableState: bindActionCreators(
		setTableStateActionCreator,
		dispatch
	),
});

export default compose(
	withRouter,
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps),
	withSnackbar,
)(ListView);
